module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-12day-premium@2-2877831c60819dd95f2da1096213041c.png";